import type { IFuseOptions } from 'fuse.js'
import {
  type FuzzySearchResult,
  useFuzzySearch,
} from '@/components/admin/shared/hooks/use-fuzzy-search'
import type { CoachingQuestion } from '../types'

/** Search across the problem's own name plus every source's title/id. */
export const PROBLEM_SEARCH_KEYS: NonNullable<
  IFuseOptions<CoachingQuestion>['keys']
> = [
  { name: 'name', weight: 0.4 },
  { name: 'externalId', weight: 0.15 },
  { name: 'allSources.title', weight: 0.25 },
  { name: 'allSources.source', weight: 0.1 },
  { name: 'allSources.externalId', weight: 0.1 },
]

export type ProblemSearchResult = FuzzySearchResult<CoachingQuestion>

export function useProblemSearch(problems: CoachingQuestion[]) {
  return useFuzzySearch(problems, PROBLEM_SEARCH_KEYS)
}
